define('orderDetailCompositionView',[
  'module',
  'marionette',
  'settings',
  'app',
  'backbone',
  'jquery',
  'bootbox',
  'noItemsView',
  'template!orderCompositionTabTpl',
  'template!orderCompositionItemTpl',
  'compuzzProUtils',
  'underscore',
  'rolesMixin',
  'vectorizationCollectionView',
  'similarCollectionView',
  'googleImageCollectionView',
  'ordersDetailCompositionProofsheetView',
  'orderPicturesTabPictureCollectionView',
  'ordersDetailOrderClientImagesView',
  'previewPopover',
  'entities/orders',
  'entities/composition_vectorization',
  'entities/pim_product'
], function (
  module,
  Marionette,
  Settings,
  App,
  Backbone,
  $,
  bootbox,
  NoItemsView,
  compositionTabTpl,
  compositionItemTpl,
  CompuzzProUtils,
  _,
  RolesMixin,
  VectorizationCollectionView,
  SimilarCollectionView,
  GoogleImageCollectionView,
  CompositionProofsheetView,
  OrderPicturesView,
  ImagesView,
  PreviewPopover
) {
  'use strict';

  var CompositionItemView = Marionette.LayoutView.extend({
    letters: ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q',
      'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'],
    template: compositionItemTpl,

    ui: {
      compositionImg: '.composition-img',
      useBackgroundColor: '.useBackgroundColor',
      jsLoader: '.js-loading-block',
      btnLoadGoogleImage: '.btn-load-google-images',
      printAreaPreview: '.js-printarea-preview'
    },

    regions: {
      vectorizationRegion: '.vectorization-region',
      similarRegion: '.similar-region',
      googleImageRegion: '.google-image-region'
    },

    events: {
      'click .btn-edit-compuzzpro': 'onCompuzzProEditClick',
      'change @ui.useBackgroundColor': 'onChangeUseBackgroundColor',
      'click .btn-edit-property': 'onClickEditProperty',
      'click .btn-delete-print-area': 'onDeletePrintArea',
      'click @ui.btnLoadGoogleImage': 'onLoadGoogleImages',
      'click .btn-check-stroke': 'onCheckStrokeClick',
      'click .btn-check-stroke-pixel': 'onCheckStrokePixelClick',
      'click @ui.printAreaPreview': 'onPrintAreaPreviewClick'
    },

    onPrintAreaPreviewClick: function () {
      var url = this.ui.printAreaPreview.attr('data-link');
      if (url) {
        window.open(url, '_blank');
      }
    },

    onCheckStrokeClick: function () {
      this.checkStroke = true;
      $.ajax({
        url: Settings.url('compuzz2', 'personalization.json/compositions/' + this.model.get('secId') + '/checkstroke', {
          strokeWidth: this.minStrokeWidth,
          strokeLength: this.minStrokeWidth,
          strokeWidthTexts: this.minStrokeWidth,
          strokeLengthTexts: this.minStrokeWidth,
          deviation: 0.3,
          step: 0.3
        }),
        type: 'GET',
        success: _.bind(function (result) {
          if (!result || !result.value) {
            bootbox.alert(_.i18n('common.noStrokeError'));
          }
        }, this),
        error: function () {
        }
      });
      this.render();
    },

    onCheckStrokePixelClick: function () {
      var self = this;
      var MIN_STROKE_MM = 0.5;
      this.checkStroke = true;

      var selectedPz = _.findWhere(this.model.get('availablePzs'), {id: this.model.get('pzId')});
      var pzWidthMm = (selectedPz && selectedPz.width) ||
        (this.model.get('customData') && this.model.get('customData').pzWidth);

      if (!pzWidthMm) {
        bootbox.alert('Print zone width not available for pixel analysis.');
        return;
      }

      var imgUrl = this.getPrintAreaImgUrl().replace('/snapshot/withMeasure', '/snapshot');
      if (imgUrl.indexOf('nobg=') === -1) {
        imgUrl += '&nobg=true';
      }
      var img = new Image();
      img.crossOrigin = 'anonymous';

      img.onload = function () {
        var imgW = img.naturalWidth || img.width;
        var imgH = img.naturalHeight || img.height;
        var canvas = document.createElement('canvas');
        canvas.width = imgW;
        canvas.height = imgH;
        var ctx = canvas.getContext('2d');

        var imageData;
        try {
          ctx.drawImage(img, 0, 0);
          imageData = ctx.getImageData(0, 0, imgW, imgH);
        } catch (e) {
          bootbox.alert('Cannot analyse image pixels due to cross-origin restrictions. ' +
            'Please configure the image server to allow cross-origin access.');
          return;
        }

        var pxPerMm = imgW / pzWidthMm;
        var minStrokePx = Math.max(1, Math.ceil(MIN_STROKE_MM * pxPerMm));
        var result = self.performPixelStrokeAnalysis(imageData, imgW, imgH, minStrokePx);

        var statusHtml;
        if (result.hasThinStrokes) {
          statusHtml = '<p style="color:#d9534f;font-weight:bold;"><i class="mdi-alert-warning"></i> ' +
            'Issues found - yellow/black hatched areas show strokes thinner than ' + MIN_STROKE_MM + 'mm</p>';
        } else {
          statusHtml = '<p style="color:#5cb85c;font-weight:bold;"><i class="mdi-action-check-circle"></i> ' +
            'All strokes meet the ' + MIN_STROKE_MM + 'mm minimum width</p>';
        }

        var infoHtml = '<div>' + statusHtml +
          '<small>Print zone: ' + pzWidthMm + 'mm wide, ' + pxPerMm.toFixed(1) +
          ' px/mm | Minimum stroke: ' + MIN_STROKE_MM + 'mm = ' + minStrokePx + 'px</small></div>';

        bootbox.dialog({
          title: 'Pixel Stroke Width Check',
          message: infoHtml,
          buttons: {close: {label: 'Close', className: 'btn-primary'}}
        });

        setTimeout(function () {
          var $body = $('.bootbox.modal .modal-body');
          result.canvas.style.maxWidth = '100%';
          result.canvas.style.marginTop = '10px';
          result.canvas.style.display = 'block';
          $body.append(result.canvas);
        }, 50);
      };

      img.onerror = function () {
        bootbox.alert('Failed to load the composition image for analysis.');
      };

      img.src = imgUrl;
    },

    performPixelStrokeAnalysis: function (imageData, width, height, minStrokePx) {
      var data = imageData.data;
      var n = width * height;
      // Pixels within this RGBA distance are considered the same color region.
      // Generous enough to absorb JPEG/anti-alias artifacts without losing real boundaries.
      var COLOR_TOL = 40;
      var ALPHA_MIN = 128; // skip semi-transparent anti-aliased edge pixels — only check solid ink

      var thin = new Uint8Array(n);
      var hasThinStrokes = false;

      for (var y = 0; y < height; y++) {
        for (var x = 0; x < width; x++) {
          var idx = y * width + x;
          if (data[idx * 4 + 3] < ALPHA_MIN) { continue; }

          var r0 = data[idx * 4], g0 = data[idx * 4 + 1], b0 = data[idx * 4 + 2];
          var l = 0, r = 0, u = 0, d = 0, ni;

          // Scan left (capped at minStrokePx for performance — interior pixels exit early)
          ni = idx - 1;
          while (l < minStrokePx && x - l - 1 >= 0 &&
                 data[ni * 4 + 3] >= ALPHA_MIN &&
                 Math.abs(data[ni * 4]     - r0) <= COLOR_TOL &&
                 Math.abs(data[ni * 4 + 1] - g0) <= COLOR_TOL &&
                 Math.abs(data[ni * 4 + 2] - b0) <= COLOR_TOL) { l++; ni--; }

          // Scan right
          ni = idx + 1;
          while (r < minStrokePx && x + r + 1 < width &&
                 data[ni * 4 + 3] >= ALPHA_MIN &&
                 Math.abs(data[ni * 4]     - r0) <= COLOR_TOL &&
                 Math.abs(data[ni * 4 + 1] - g0) <= COLOR_TOL &&
                 Math.abs(data[ni * 4 + 2] - b0) <= COLOR_TOL) { r++; ni++; }

          if (l + r + 1 < minStrokePx) {
            thin[idx] = 1;
            continue; // already thin in H — no need to check V
          }

          // Scan up
          ni = idx - width;
          while (u < minStrokePx && y - u - 1 >= 0 &&
                 data[ni * 4 + 3] >= ALPHA_MIN &&
                 Math.abs(data[ni * 4]     - r0) <= COLOR_TOL &&
                 Math.abs(data[ni * 4 + 1] - g0) <= COLOR_TOL &&
                 Math.abs(data[ni * 4 + 2] - b0) <= COLOR_TOL) { u++; ni -= width; }

          // Scan down
          ni = idx + width;
          while (d < minStrokePx && y + d + 1 < height &&
                 data[ni * 4 + 3] >= ALPHA_MIN &&
                 Math.abs(data[ni * 4]     - r0) <= COLOR_TOL &&
                 Math.abs(data[ni * 4 + 1] - g0) <= COLOR_TOL &&
                 Math.abs(data[ni * 4 + 2] - b0) <= COLOR_TOL) { d++; ni += width; }

          if (u + d + 1 < minStrokePx) {
            thin[idx] = 1;
          }
        }
      }

      // Pass 1: remove colour-boundary artifacts.
      // A thin pixel is removed only when ALL 4 orthogonal neighbours are opaque AND
      // at least one pair of opposite neighbours (L↔R or U↔D) differs significantly
      // in colour — meaning the pixel bridges two different ink regions rather than
      // being a genuine thin feature enclosed within a single ink colour (e.g. white
      // globe grid lines surrounded by a blue fill must NOT be removed here).
      for (var pi = 0; pi < n; pi++) {
        if (!thin[pi]) { continue; }
        var pcx = pi % width, pcy = Math.floor(pi / width);
        if (pcx < 1 || pcx >= width - 1 || pcy < 1 || pcy >= height - 1) { continue; }
        var li = (pcy * width + pcx - 1) * 4, ri = (pcy * width + pcx + 1) * 4;
        var ui = ((pcy - 1) * width + pcx) * 4, di = ((pcy + 1) * width + pcx) * 4;
        if (data[li + 3] < ALPHA_MIN || data[ri + 3] < ALPHA_MIN ||
            data[ui + 3] < ALPHA_MIN || data[di + 3] < ALPHA_MIN) { continue; }
        // All 4 neighbours opaque: only remove if at least one opposite pair of
        // neighbours has significantly different colours (the pixel bridges two ink regions).
        var lrDiff = Math.abs(data[li]     - data[ri])     > COLOR_TOL ||
                     Math.abs(data[li + 1] - data[ri + 1]) > COLOR_TOL ||
                     Math.abs(data[li + 2] - data[ri + 2]) > COLOR_TOL;
        var udDiff = Math.abs(data[ui]     - data[di])     > COLOR_TOL ||
                     Math.abs(data[ui + 1] - data[di + 1]) > COLOR_TOL ||
                     Math.abs(data[ui + 2] - data[di + 2]) > COLOR_TOL;
        if (lrDiff || udDiff) { thin[pi] = 0; }
      }

      // Pass 2: remove tiny connected clusters (corner/tip pixels of thick letterforms).
      // Only keep clusters of more than minStrokePx pixels — real thin strokes
      // span a meaningful length; corner artifacts are just a handful of pixels.
      var visited = new Uint8Array(n);
      for (var si = 0; si < n; si++) {
        if (!thin[si] || visited[si]) { continue; }
        var stack = [si];
        visited[si] = 1;
        var component = [];
        while (stack.length > 0) {
          var curr = stack.pop();
          component.push(curr);
          var cx = curr % width;
          var cy = Math.floor(curr / width);
          for (var dy = -1; dy <= 1; dy++) {
            for (var dx = -1; dx <= 1; dx++) {
              if (dx === 0 && dy === 0) { continue; }
              var nx = cx + dx;
              var ny = cy + dy;
              if (nx < 0 || nx >= width || ny < 0 || ny >= height) { continue; }
              var nidx = ny * width + nx;
              if (thin[nidx] && !visited[nidx]) {
                visited[nidx] = 1;
                stack.push(nidx);
              }
            }
          }
        }
        // A real thin stroke needs at least minStrokePx² pixels:
        // it must span roughly minStrokePx in its longest direction while still
        // being thin (< minStrokePx) in its shortest direction.
        // Corner/tip artifacts of thick letterforms are always smaller than this.
        if (component.length < minStrokePx * minStrokePx) {
          for (var ki = 0; ki < component.length; ki++) {
            thin[component[ki]] = 0;
          }
        }
      }

      hasThinStrokes = false;
      for (var hi = 0; hi < n; hi++) {
        if (thin[hi]) { hasThinStrokes = true; break; }
      }

      // Build result canvas: checkerboard + image (alpha-composited) + red thin-stroke overlay
      var resultCanvas = document.createElement('canvas');
      resultCanvas.width = width;
      resultCanvas.height = height;
      var rCtx = resultCanvas.getContext('2d');

      // Draw Photoshop-style checker so transparent areas are visible
      var tile = 10;
      for (var ty = 0; ty < height; ty += tile) {
        for (var tx = 0; tx < width; tx += tile) {
          rCtx.fillStyle = ((Math.floor(tx / tile) + Math.floor(ty / tile)) % 2 === 0) ? '#ffffff' : '#cccccc';
          rCtx.fillRect(tx, ty, tile, tile);
        }
      }

      // Composite the original image (respects alpha, so white artwork shows on grey tiles)
      var tmpCanvas = document.createElement('canvas');
      tmpCanvas.width = width;
      tmpCanvas.height = height;
      tmpCanvas.getContext('2d').putImageData(imageData, 0, 0);
      rCtx.drawImage(tmpCanvas, 0, 0);

      // Paint thin-stroke pixels with a 1px yellow/black checkerboard.
      // Yellow (#ffff00) is always visible on dark/red/blue artwork;
      // black (#000000) is always visible on white/yellow/light artwork.
      // Together the two-tone pattern is guaranteed to stand out on any artwork colour.
      if (hasThinStrokes) {
        var out = rCtx.getImageData(0, 0, width, height);
        var od = out.data;
        for (var j = 0; j < n; j++) {
          if (!thin[j]) { continue; }
          var px = j % width;
          var py = Math.floor(j / width);
          if ((px + py) % 2 === 0) {
            od[j * 4] = 255; od[j * 4 + 1] = 255; od[j * 4 + 2] = 0;   // yellow
          } else {
            od[j * 4] = 0;   od[j * 4 + 1] = 0;   od[j * 4 + 2] = 0;   // black
          }
          od[j * 4 + 3] = 255;
        }
        rCtx.putImageData(out, 0, 0);
      }

      return {canvas: resultCanvas, hasThinStrokes: hasThinStrokes};
    },

    onChangeUseBackgroundColor: function () {
      $('.loading-block').show();
      App.request('order:update-use-background-color', this.model.collection.orderModel.get('purchaseOrderId'), this.model.get('secId'),
        this.ui.useBackgroundColor.prop('checked')).then(_.bind(function () {
        CompuzzProUtils.getInstance().trigger('notificationCenter:compuzzProRefreshComposition');
        $('.loading-block').hide();
      }, this));
    },

    forceNotDesign2: false,

    onRender: function () {
      $.material.init();
      var useBackgroundColor = this.model.get('useBackgroundColor') || false;
      this.ui.useBackgroundColor.prop('checked', useBackgroundColor);

      if (this.ui.printAreaPreview && this.ui.printAreaPreview.length) {
        PreviewPopover.attach(this.ui.printAreaPreview, this.ui.printAreaPreview.attr('data-link'), {
          container: $('#content'),
          namespace: 'compositionZoom'
        });
      }
      /*
      if (this.forceNotDesign2 || !Settings.get('cAccountRoles')[RolesMixin.DASHBOARD_ORDERS_DESIGN2] ||
        this.model.collection.orderModel.get('commandType') === 'offer') {
        var col = App.request('composition-vectorization:get-collection', this.model.get('secId'));
        col.fetch();
        this.vectorizationsView = new VectorizationCollectionView({
          collection: col
        });

        this.getRegion('vectorizationRegion').show(this.vectorizationsView);

        var col2 = App.request('composition-similar:get-collection', this.model.get('secId'));
        col2.fetch();
        this.similarsView = new SimilarCollectionView({
          collection: col2
        });

        this.getRegion('similarRegion').show(this.similarsView);
      }
       */
    },

    onDestroy: function () {
      PreviewPopover.detach(this.ui.printAreaPreview);
      $('.jqgrid-popover').remove();
    },

    onLoadGoogleImages: function () {
      this.ui.jsLoader.show();
      this.ui.btnLoadGoogleImage.hide();
      var col3 = App.request('composition-google-image:get-collection', this.model.get('secId'));
      col3.fetch().done(_.bind(function () {
        this.googleImagesView = new GoogleImageCollectionView({
          collection: col3
        });
        this.getRegion('googleImageRegion').show(this.googleImagesView);
      }, this));
    },

    serializeData: function () {
      var templateData = this.model.toJSON();
      templateData.displayEditButtons = true;
     /* if (this.model.collection.orderModel.get('pim')) {
        templateData.displayEditButtons = false;
      }*/

      if (templateData.exportFileUid && !!Settings.configValue('advancedMode')) {
        templateData.customExportUrl = Settings.url('file', templateData.exportFileUid) + '&cmds=on';
      } else {
        templateData.exportFileUid = '';
      }

      templateData.printZones = [];

      _.each(templateData.availablePzs, _.bind(function (pz) {
        if (pz.colorModeType !== 'spot') {
          pz.maxColors = '';
        }
        if (pz.colorModeType === 'quadri') {
          pz.digital = true;
        } else {
          pz.digital = '';
        }
        if (pz.colorModeType === 'fixedFilling') {
          pz.eng = true;
        } else {
          pz.eng = '';
        }

        pz.productionTime = '';
        if(pz.productionTimes) {
          _.each(pz.productionTimes, function (productionTime) {
            if (productionTime.from && productionTime.to) {
              if(this.model.collection.orderModel.get('quantity') >= productionTime.from &&
                this.model.collection.orderModel.get('quantity') <= productionTime.to) {
                pz.productionTime = '(Production time: ' + productionTime.days + ' days)';
              }
            }
          }, this);
        }
        
      }, this));

      templateData.advancedMode = !!Settings.configValue('advancedMode');
      templateData.orderQuantity = this.model.collection.orderModel.get('quantity') || 0;
      templateData.selectedPzMinQtyExceeded = false;
      if (templateData.advancedMode) {
        var selectedPz = _.findWhere(templateData.availablePzs, {id: this.model.get('pzId')});
        if (selectedPz && selectedPz.minimumQuantity > 1 && selectedPz.minimumQuantity > templateData.orderQuantity) {
          templateData.selectedPzMinQtyExceeded = true;
        }
      }
      templateData.tokenId = Settings.get('tokenId');
      if (Settings.compuzzAwsWsSend) {
        templateData.tokenId += '-v2';
      }
      templateData.customData = this.model.get('customData');
      templateData.prinAreaImgUrl = this.getPrintAreaImgUrl();
      templateData.printAreaName = this.model.get('paName') ? (this.getPrintAreaCode() + ' - ' +
        this.model.get('paName')) : this.getPrintAreaCode();
      templateData.printZone = this.model.get('pzId');

      var pzPictures = (this.options && this.options.pzPictures) || {};
      var currentPzPictures = pzPictures[this.model.get('pzId')] || [];
      templateData.previewImgUrl = currentPzPictures.length > 0 ? currentPzPictures[0].imageUrl : '';

      templateData.compuzzProProtocol = 'cpzp';
      if (Settings.compuzzProProtocol) {
        templateData.compuzzProProtocol = Settings.compuzzProProtocol;
      }
      templateData.editorUrl = Settings.editorUrl;

      if (!this.forceNotDesign2 && Settings.get('cAccountRoles')[RolesMixin.DASHBOARD_ORDERS_DESIGN2] &&
        this.model.collection.orderModel.get('commandType') !== 'offer') {
        templateData.notDesign2 = false;
      } else {
        templateData.notDesign2 = true;
      }

      templateData.displayCheckStroke = false;
      _.each(this.model.collection.productModel.get('printAreas'), _.bind(function (pa) {
        _.each(pa.printZones, _.bind(function (pz) {
          if (pz.id === this.model.get('pzId') && pz.minStrokeWidth) {
            this.minStrokeWidth = pz.minStrokeWidth;
            templateData.displayCheckStroke = true;
          }
        }, this));
      }, this));

      //---------------
      templateData.warning = '';
      var productPz = null;

      var productPa = _.findWhere(this.model.collection.productModel.get('printAreas'), {'id': this.model.get('paId')});
      if (!productPa)
        productPa = _.findWhere(this.model.collection.productModel.get('printAreas'), {'code': this.model.get('paCode')});

      if (productPa) {
        productPz = _.findWhere(productPa.printZones, {'id': this.model.get('pzId')});
        if (!productPz) {
          productPz = _.findWhere(productPa.printZones, {'imppCode': this.model.get('itCode')});
        }
        if (productPz) {
           if (productPz && this.model.get('usedColors') && this.model.get('usedColors').length > productPz.maxColors) {
             templateData.warning = _.i18n('orders.detail.printzones.warning');
             templateData.warning = templateData.warning.replace('%max-colors', productPz.maxColors);
             templateData.warning = templateData.warning.replace('%used-colors', this.model.get('usedColors').length);
           }
        }
      }

      return templateData;
    },

    getPrintAreaCode: function () {
      if (Settings.get('currentCAccount').displayPaCodeLetter) {
        var letter = this.letters[parseInt(this.model.get('paCode'), 10) - 1];
        return letter ? letter : this.model.get('paCode');
      } else {
        return this.model.get('paCode');
      }
    },

    onCompuzzProEditClick: function () {
      CompuzzProUtils.getInstance().sendData({
        value: 'edit compo',
        type: 'compuzzProEditComposition',
        tokenId: Settings.get('tokenId'),
        compositionSecId: this.model.get('secId')
      });
    },

    onDeletePrintArea: function (e) {
      App.request('order:remove-print-zone', this.model.collection.orderModel.get('purchaseOrderId'),
        $(e.target).parent().attr('printzone')).done(_.bind(function () {
        this.model.collection.orderModel.fetch();
      }, this));
    },

    getPrintAreaImgUrl: function () {
      var params = {};
      if (!this.model.get('useBackgroundColor')) {
        params.nobg = true;
      }
      params.productCode = this.model.collection.orderModel.get('productBaseCode');
      params.pac = this.model.get('paCode');
      params.t = new Date().getTime();
      var base = this.checkStroke ? 'x2png2' : 'x2png';
      if (Settings.get('cAccountRoles')[RolesMixin.DASHBOARD_ORDERS_DESIGN2]) {
        return Settings.url(base, 'compositions/' + this.model.get('secId') + '/snapshot', params);
      } else {
        return Settings.url(base, 'compositions/' + this.model.get('secId') + '/snapshot/withMeasure', params);
      }
    }
  });

  var CompositionCollectionView = Marionette.CollectionView.extend({
    childView: CompositionItemView,
    childViewOptions: function () {
      return {
        pzPictures: this.options.pzPictures || {}
      };
    }
  });

  var CompositionTabView = Marionette.LayoutView.extend({
    template: compositionTabTpl,
    className: 'content order-personalization',

    ui: {
      txtInternalComment: '.order-internal-comment'
    },

    regions: {
      prinAreaItem: '.js-print-area-container-region',
      proofsheetRegion: '.proofsheet-region',
      additionalVariationImagesRegion: '.js-additional-variation-images-region',
      vrpsRegion: '.vrps-region'
    },

    events: {
      'click .js-delete-custom-export': 'onDeleteCustomExport',
      'click .btn-edit-compuzz': 'onCompuzzEditClick',
      'change @ui.txtInternalComment': 'onInternalCommentChanged',
      'change .itName': 'onPZchange',
      'click .add-print-area-btn': 'onToggleAddPrintAreaMenu',
      'click .add-print-area-item': 'onAddPrintArea'
    },

    onToggleAddPrintAreaMenu: function (e) {
      e.stopPropagation();
      var $dropdown = this.$('.add-print-area-dropdown');
      $dropdown.toggleClass('open');
      if ($dropdown.hasClass('open')) {
        var $menu = $dropdown.find('.add-print-area-menu');
        setTimeout(function () {
          if (!$menu.length) return;
          var rect = $menu[0].getBoundingClientRect();
          var viewportHeight = window.innerHeight || document.documentElement.clientHeight;
          if (rect.bottom > viewportHeight) {
            $menu[0].scrollIntoView({behavior: 'smooth', block: 'nearest'});
          }
        }, 0);
      }
    },

    serializeData: function () {
      var templateData = this.orderModel.toJSON();
      if (templateData.exportFileUid) {
        templateData.customExportUrl = Settings.url('file', templateData.exportFileUid) + '&cmds=on';
      }

      templateData.comment = this.options.productModel.get('comment');
      if (!templateData.comment) {
        templateData.comment = '';
      }

      if (Settings.configValue('orders.showCompuzzVrpOnPimOrder')) {
        templateData.additionalVariationImages = true;
      } else {
        templateData.additionalVariationImages = false;
      }

      templateData.printAreas = [];
      var usedPrintArea = this.options.collection.orderModel.get('compositions');
      _.each(this.printAreas, function (availablePrintArea) {
        var pa = _.findWhere(usedPrintArea, {paId: availablePrintArea.id});
        if (!pa) {
          templateData.printAreas.push(availablePrintArea);
        }
      });

      if (Settings.get('cAccountRoles')[RolesMixin.DASHBOARD_ORDERS_DESIGN2] &&
        this.options.collection.orderModel.get('commandType') !== 'offer') {
        templateData.notDesign2 = false;
      } else {
        templateData.notDesign2 = true;
      }

      templateData.advancedMode = !!Settings.configValue('advancedMode');

      return templateData;
    },

    // Hand the fetched print-zone pictures to the proofsheet view so its PDF
    // editor can show them as read-only print-area reference images. The pictures
    // arrive asynchronously, after the proofsheet view has already been created.
    setProofsheetPzPictures: function (pzPictures) {
      this.pzPictures = pzPictures;
      if (this.proofsheetView) {
        this.proofsheetView.options.pzPictures = pzPictures;
      }
    },

    updatePrintAreaThumbnails: function (pzPictures) {
      if (Settings.configValue('advancedMode') !== true) {
        return;
      }
      var self = this;
      this.$('.add-print-area-thumb').each(function () {
        var $img = $(this);
        var paId = $img.attr('data-pa-id');
        var pa = _.find(self.printAreas, function (p) {
          return p.id.toString() === paId.toString();
        });
        if (!pa || !pa.printZones || !pa.printZones.length) {
          return;
        }
        var pictures = pzPictures[pa.printZones[0].id] || [];
        if (pictures.length === 0) {
          return;
        }
        PreviewPopover.attach($img, pictures[0].imageUrl, {namespace: 'dropdownZoom'});
      });
    },

    onShow: function () {

      $(document).on('click.compositionAddMenu', _.bind(this.onDocumentClick, this));

      if(this.orderModel.get('pim')) {
        this.pimProduct = App.request('pim:products:model', {id: this.orderModel.get('productSecId')});
        this.pimProduct.fetch().done(_.bind(function () {
          var pzPictures = this.extractPimPrintPictures();
          this.setProofsheetPzPictures(pzPictures);
          this.updatePrintAreaThumbnails(pzPictures);
          if (this.collection.models.length !== 0) {
            var availablePrAreas = this.options.productModel.get('printAreas');
            _.each(this.collection.models, _.bind(function (model) {
              var pa = _.findWhere(availablePrAreas, {'id': model.get('paId')});
              var availablePrintZones = pa ? pa.printZones : [];

              _.each(availablePrintZones, _.bind(function (pz) {
                var ptMinQty = this.getProductionTimesAndMinimumQuantity(pz.id);
                pz.productionTimes = ptMinQty.productionTimes;
                pz.minimumQuantity = ptMinQty.minimumQuantity;
              }, this));
              model.set('availablePzs', availablePrintZones);
            }, this));

            if (this.getRegion('prinAreaItem')) {
              this.getRegion('prinAreaItem').show(new CompositionCollectionView({collection: this.collection, pzPictures: pzPictures}));
            }
          } else {
            if (this.getRegion('prinAreaItem')) {
              this.getRegion('prinAreaItem').show(new NoItemsView());
            }
          }
        }, this));
      } else {
        var compositionCollectionView = null;
        if (this.collection.models.length !== 0) {
          var availablePrAreas = this.options.productModel.get('printAreas');

          _.each(this.collection.models, _.bind(function (model) {
            var pa = _.findWhere(availablePrAreas, {'id': model.get('paId')});
            var availablePrintZones = pa ? pa.printZones : [];

            _.each(availablePrintZones, _.bind(function (pz) {
              pz.productionTimes = null;
            }, this));
            model.set('availablePzs', availablePrintZones);
          }, this));

          compositionCollectionView = new CompositionCollectionView({collection: this.collection, pzPictures: {}});
          this.getRegion('prinAreaItem').show(compositionCollectionView);
        } else {
          this.getRegion('prinAreaItem').show(new NoItemsView());
        }

        if (Settings.configValue('advancedMode') === true) {
          App.request('product:get-printareas', this.options.productModel.get('code')).done(_.bind(function (printAreas) {
            var pzPictures = {};
            _.each(printAreas, function (pa) {
              _.each(pa.printZones, function (pz) {
                pzPictures[pz.id] = pz.printPictures || [];
              });
            });
            if (compositionCollectionView) {
              compositionCollectionView.options.pzPictures = pzPictures;
              _.each(compositionCollectionView.children._views, function (childView) {
                childView.options.pzPictures = pzPictures;
                childView.render();
              });
            }
            this.setProofsheetPzPictures(pzPictures);
            this.updatePrintAreaThumbnails(pzPictures);
          }, this));
        }
      }

      //-----------------
      this.proofsheetView = new CompositionProofsheetView({
        model: this.orderModel,
        pzPictures: this.pzPictures || {}
      });
      this.listenTo(this.proofsheetView, 'editCustomProofsheet', this.onCustomProofsheetCompuzzProEditClick);
      this.getRegion('proofsheetRegion').show(this.proofsheetView);

      if (Settings.configValue('orders.showCompuzzVrpOnPimOrder')) {
        this.imagesView = new ImagesView({
          model: this.orderModel,
          product: this.options.productModel
        });
        this.getRegion('additionalVariationImagesRegion').show(this.imagesView);
        this.listenTo(this.imagesView, 'update:complete', function (status,msg) {
          this.showWarning(status,msg);
        });

        var vrpsCollection = new Backbone.Collection();
        if (this.orderModel.get('pim')) {
          this.orderModel.compuzzVrps().then(_.bind(function (vrps) {
            this.urls = this.orderModel.getImageUrls(this.options.productModel, vrps);
            vrpsCollection.reset();
            _.each(this.urls, function (image, index) {
              var model = new Backbone.Model({
                url: this.addTimestampToUrl(this.addMinSizeToUrl(image.url)),
                secId: image.secId,
                ambiance: image.ambiance,
                index: index,
                orderModel: this.orderModel
              });
              vrpsCollection.add(model);
            }, this);
            this.showVrpsRegion(vrpsCollection);
          }, this));
        } else {
          this.urls = this.orderModel.getImageUrls(this.options.productModel);
          vrpsCollection.reset();
          _.each(this.urls, function (image, index) {
            var model = new Backbone.Model({
              url: this.addTimestampToUrl(image.url),
              secId: image.secId,
              ambiance: image.ambiance,
              index: index,
              orderModel: this.orderModel
            });
            vrpsCollection.add(model);
          }, this);
          this.showVrpsRegion(vrpsCollection);
        }
      }
    },

    extractPimPrintPictures: function () {
      var pzPictures = {};
      if (Settings.configValue('advancedMode') !== true) {
        return pzPictures;
      }
      if (this.pimProduct && this.pimProduct.get('data') && this.pimProduct.get('data').get('printAreas')) {
        this.pimProduct.get('data').get('printAreas').each(function (pa) {
          pa.get('printZones').each(function (pz) {
            pzPictures[pz.get('pimId')] = pz.get('printPictures') || [];
          });
        });
      }
      return pzPictures;
    },

    getProductionTimesAndMinimumQuantity: function (pzId) {
      var result = {
        productionTimes: null,
        minimumQuantity: null
      };

      if(!this.pimProduct) 
        return result;
     
      if(!this.pimProduct.get('data')) 
        return result;

      if(!this.pimProduct.get('data').get('printAreas')) 
        return result;

      _.each(this.pimProduct.get('data').get('printAreas').models, function (pa) {
        _.each(pa.get('printZones').models, function (pz) {
          if (pz.get('pimId') === pzId) {
            result.productionTimes = pz.get('productionTimes');
            result.minimumQuantity = pz.get('minimumQuantity');
          }
        });
      });        

      return result;
    },

    onCustomProofsheetCompuzzProEditClick: function () {
      CompuzzProUtils.getInstance().sendData({
        value: 'edit compo',
        type: 'compuzzProEditCustomProofsheet',
        tokenId: Settings.get('tokenId'),
        poi: this.orderModel.get('poi')
      });
    },

    // Append a cache-busting timestamp so the configurator / x2png image
    // is re-fetched after a recompose instead of rendering a stale cached
    // version. Scoped to the vrps-region URLs only.
    addTimestampToUrl: function (url) {
      if (!url) {
        return url;
      }
      var separator = url.indexOf('?') === -1 ? '?' : '&';
      return url + separator + 'ts=' + new Date().getTime();
    },

    // Request a minimum render size from x2png for configurator images so the
    // small vrps-region thumbnails are not served at a too-low resolution.
    addMinSizeToUrl: function (url) {
      if (!url || url.indexOf('/configurator') === -1) {
        return url;
      }
      var separator = url.indexOf('?') === -1 ? '?' : '&';
      return url + separator + 'minWidth=200&minHeight=200';
    },

    showVrpsRegion: function(collection) {
      if (this.getRegion('vrpsRegion')) {
        this.vrpsRegion = new OrderPicturesView({
          collection: collection
        });
        this.getRegion('vrpsRegion').show(this.vrpsRegion);
      }
    },

    showWarning: function (value,msg) {
      if (this.ui && this.ui.warning) {
        if (value) {
          this.ui.warning.show();
          this.ui.warning.text(msg);
        } else {
          this.ui.warning.hide();
        }
      }
    },

    onInternalCommentChanged: function () {
      $('.loading-block').show();
      this.orderModel.set('internalComment', this.ui.txtInternalComment.val());
      $.when(App.request('order:update', {
        purchaseOrderId: this.orderModel.get('purchaseOrderId'),
        internalComment: this.orderModel.get('internalComment')
      })).done(_.bind(function () {
        $('.loading-block').hide();
      }, this));
    },

    onDeleteCustomExport: function (e) {
      $('.loading-block').show();

      // Get the composition ID if available (from data attribute or parent element)
      var compositionId = null;
      if (e && e.currentTarget) {
        compositionId = $(e.currentTarget).data('composition-id');
        if (!compositionId && $(e.currentTarget).closest('.order-composition-tab').length) {
          // If we're in a composition item, try to get the composition ID from the model
          var compositionItem = $(e.currentTarget).closest('.order-composition-tab');
          var compositionIndex = $('.order-composition-tab').index(compositionItem);
          if (compositionIndex >= 0 && this.collection && this.collection.models[compositionIndex]) {
            compositionId = this.collection.models[compositionIndex].get('secId');
          }
        }
      }

      App.request('order:delete-custom-export', this.orderModel.get('purchaseOrderId'), compositionId).then(_.bind(function () {
        this.orderModel.set('exportFileUid', null);
        CompuzzProUtils.getInstance().trigger('notificationCenter:compuzzProRefreshComposition');
        $('.loading-block').hide();
      }, this));
    },

    onCompuzzEditClick: function (e) {
      var printZone = $(e.currentTarget).attr('printZone');
      var poi = this.collection.orderModel.id;
      this.trigger('editor:open', poi, printZone, Settings.editorUrl, this.collection.orderModel.get('pim'));
    },

    onPZchange: function (e) {
      App.request('order:update-printzone', this.orderModel.get('purchaseOrderId'),
        $(e.target).attr('currentPrintzone'),
        $(e.target).find(':selected').val(), null).then(
        _.bind(function () {
          this.orderModel.fetch();
          //window.location.reload();
        }, this)
      );
    },

    onAddPrintArea: function (e) {
      var paId = $(e.currentTarget).attr('data-pa-id');
      var pa = _.find(this.printAreas, function (pa) {
        return pa.id.toString() === paId.toString();
      });
      if (!pa) {
        return;
      }
      var pz = pa.printZones[0];
      this.$('.add-print-area-dropdown').removeClass('open');
      App.request('order:add-printzone', this.orderModel.get('purchaseOrderId'), pz.id,
          (pz.colorModeType==='spot'?1:undefined)).then(
        _.bind(function () {
          this.orderModel.fetch();
        }, this)
      );
    },

    onDocumentClick: function (e) {
      if (!$(e.target).closest('.add-print-area-dropdown').length) {
        this.$('.add-print-area-dropdown').removeClass('open');
      }
    },

    onDestroy: function () {
      $(document).off('click.compositionAddMenu');
      this.$('.add-print-area-thumb').each(function () {
        if ($(this).data('bs.popover')) {
          $(this).popover('destroy');
        }
      });
      $('.jqgrid-popover').remove();
    }
  });

  module.exports = CompositionTabView;
});

